import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["to", "children", "origin"];
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import React from 'react';
import { Link } from 'react-router-dom';
import { useAppNameContext } from 'hooks/useAppNameContext';
import Button from 'components/Button';
export function AdminOrHubButtonLink(props) {
  var to = props.to,
    children = props.children,
    _props$origin = props.origin,
    origin = _props$origin === void 0 ? 'admin' : _props$origin,
    otherProps = _objectWithoutProperties(props, _excluded);
  var appNameContext = useAppNameContext();
  var nonOriginPath = origin === 'admin' ? "/admin".concat(to) : to.toString();
  if (appNameContext !== origin) {
    return /*#__PURE__*/React.createElement(Button, _extends({
      target: "_blank"
    }, otherProps, {
      as: "a",
      href: nonOriginPath
    }), children);
  } else {
    return /*#__PURE__*/React.createElement(Button, _extends({}, otherProps, {
      as: Link,
      to: to
    }), children);
  }
}
export default AdminOrHubButtonLink;